module.exports = __webpack_public_path__ + "media/images/new_home/user-icon-b98d5542e14a5856d33dae384434d648.png";